<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            Summary Report
        </div>
        <div class="summary-container ppl-container">
            <div style="width: 100%">
            <ppl-report-filters (filterChanged)="filterChanged($event)" [filterFields]="filterFields"></ppl-report-filters>
        </div>
            <div class="tile-grid">
                @for (appInfo of summaryReportData; track appInfo; let idx = $index ) {
                <div class="tile" (click)="onClick(appInfo)" tabindex="0" (keydown.enter)="onClick(appInfo)" >
                    <p class="summary-heading">{{appInfo.itemName}}</p>
                    <p class="count">{{appInfo.value}}</p>
                    <p class="description">{{appInfo.description}}</p>
                </div>
                }
            </div>
        </div>
    </div>
</ng-container>